import React, { forwardRef } from 'react';

import { Button, Box, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { AppBarLocalizationMenu } from './localization';
import { AuthMenu } from './auth';
import { useLocation } from 'react-router-dom';

const ActionButtons = (props, ref) => {

    const { t } = useTranslation('public');
    let isTokenExist = localStorage.getItem("token")

    const isDownSm = useMediaQuery(theme => theme.breakpoints.down('sm'));

    const location = useLocation();
    const isMapitShip = location.pathname === '/solutions/mapit-ship';

    return (
        <Box ref={ref} >
            <AppBarLocalizationMenu reload={true} sx={{ display: { xs: 'none', md: 'inline-block' } }} />
            <AuthMenu reload={true} sx={{ display: { xs: 'inline-block', md: 'inline-block' } }} />
            {
                (!isDownSm && !isTokenExist) &&
                <Button
                    href={isMapitShip ? '/auth/general/register?role=BASIC&deliveryMethod=MAPIT_SHIP' : '/auth/general/register'}
                    variant='contained'
                    color='yellow'
                    size={isDownSm ? 'small' : 'medium'}
                    sx={{
                        height: isDownSm ? "36px" : '44px',
                        gap: isDownSm ? "4px" : '8px',
                        borderRadius: '4px',
                        textTransform: 'none',
                        marginInlineStart: isDownSm ? "5px" : '10px',
                        fontSize: isDownSm ? "12px" : '14px',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: isDownSm ? "10px" : '20px',
                    }}>
                    {t("Create Account")}
                </Button>
            }
        </Box>
    )
}

export default forwardRef(ActionButtons);